module.exports = __webpack_public_path__ + "img/product-2.d2e1d866.jpg";